import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Company Info */}
                <div className="footer-section company-info">
                    <h4>TureMedicine</h4>
                    <p>Connecting you to reliable healthcare from the comfort of your home.</p>
                </div>

                {/* Quick Links */}
                <div className="footer-section quick-links">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/services">Our Services</a></li>
                        <li><a href="/about">About Us</a></li>
                        <li><a href="/contact">Contact Us</a></li>
                        <li><a href="/faq">FAQs</a></li>
                    </ul>
                </div>

                {/* Contact Details */}
                <div className="footer-section contact-details">
                    <h4>Contact Us</h4>
                    <p>Email: support@turemedicine.com</p>
                    <p>Phone: +91-12345-67890</p>
                    <p>Address: 123, Telehealth Road, India</p>
                </div>

                {/* Social Media */}
                <div className="social-media footer">
                    <a href="https://www.facebook.com/shivendrajha.shivendra/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-facebook-f"></i> Facebook
                    </a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-twitter"></i> Twitter
                    </a>
                    <a href="https://www.instagram.com/shivendra_jha__/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-instagram"></i> Instagram
                    </a>
                    <a href="https://www.linkedin.com/in/shivendra-jha-102827215/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-linkedin-in"></i> LinkedIn
                    </a>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom">
                <p>&copy; 2024 TureMedicine. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
